import { ReactElement } from 'react'
import { styled } from '@mui/material'

interface Props {
  background: string
  icon: ReactElement
}

const BORDER_RADIUS = '10px 10px 10px 0'
export function WappIcon({ icon, background }: Props) {
  return <IconWrapper sx={{ background }}>{icon}</IconWrapper>
}

const IconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${BORDER_RADIUS};
  position: relative;
  svg {
    width: 100%;
    height: 100%;
    color: white;
  }
  path {
    fill: white;
  }
  flex-shrink: 0;
  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    border: 1px solid rgb(0, 0, 0);
    opacity: 0.1;
    border-radius: ${BORDER_RADIUS};
  }
`
